import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Switch } from '@rsos/components/capstone/base';
import { selectCapstoneAudioSettingsForFeature } from '@rsos/sinatra/src/selectors/selectAudioSettings';
import useIsIRP from '@rsos/utils/useIsIRP';
import { AdminDispatch } from '../../../../app/store';
import { usePatchAudioSettings } from '../../app/patchAudioSettings';
import SoundSelect from '../SoundSelect';
import { trackToggleSoundOnOff } from '../audioSettingsTrackings';
import styles from '../settings.module.css';

export const CallAudioSettings = () => {
  const dispatch = useDispatch<AdminDispatch>();
  const calls = useSelector(selectCapstoneAudioSettingsForFeature('calls'));

  const { sound_on: isSoundOn, tone } = calls;

  const patchAudioSettings = usePatchAudioSettings('calls');
  const updateAudioSettings = (update: Partial<typeof calls>) => {
    dispatch(patchAudioSettings(update));
  };

  const { irpVersion } = useIsIRP();

  const type = 'calls';
  const toggleSoundOn = () => {
    updateAudioSettings({ sound_on: !isSoundOn });
    trackToggleSoundOnOff(irpVersion, isSoundOn, type);
  };

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.cardTitle}>911 Calls</div>
        <div className={styles.cardDescription}>
          Notify your agents with sound when new 911 calls appear in the queue.
        </div>
      </div>
      <div className={styles.soundBlock}>
        <span>Sound Notification</span>
        <Switch onOffLabel onClick={toggleSoundOn} isOn={isSoundOn} />
      </div>
      <SoundSelect
        isSoundOn={isSoundOn}
        type={'calls'}
        tone={tone}
        updateAudioSettings={updateAudioSettings}
      />
    </div>
  );
};
